var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuceessSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#0C9900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.9531 45C71.9531 30.7614 59.8857 19.2188 45 19.2188C30.1142 19.2188 18.0469 30.7614 18.0469 45C18.0469 59.2385 30.1142 70.7812 45 70.7812C59.8857 70.7812 71.9531 59.2385 71.9531 45Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2188 46.2891L40.957 52.7344L55.7812 37.2656",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuceessSvg);
export default __webpack_public_path__ + "static/media/suceessSvg.06ee632b787ff13b703f4b750002cb84.svg";
export { ForwardRef as ReactComponent };